import React from 'react';
import { resolvePublicAssets } from '../../../../../utils';
import { getLanguage } from '../../../../../selectors/userSelectors';
import { EmmaInsuranceService } from '../../../types/EmmaInsuranceService';
import './styles.scss';
import { EmmaTestId } from '@axa-asia/auto-test-client';

export const ServiceButton = (props: EmmaInsuranceService) => {
  const { id, label, icon, enableNewFeatureDot } = props;
  return (
    <div
      className="insurance-service-button"
      data-testid={`${EmmaTestId['BUTTON_FEATURE_ICON']}-${id}`}
    >
      {enableNewFeatureDot && (
        <div className="insurance-service-button__new-feature-dot"></div>
      )}
      <div className="insurance-service-button__icon">
        <img key={id} src={resolvePublicAssets(`assets/${icon}`)} alt={id} />
        <div className="insurance-service-button__icon-shadow"></div>
      </div>
      <div className="insurance-service-button__label">
        {label?.[getLanguage()]}
      </div>
    </div>
  );
};
